import React, { useEffect, useState } from 'react'
import { Row, Table, Tag } from "antd";
import { getOffersWithPage } from "../../../services/serviceOffer";
import userDateFormatter from "../../../services/formatters/userDateFormatter";
import OfferActions from "../OfferActions";
import Filter from "../../filterWrapper/Filter";
import OfferFilter from "../filter/OfferFilter";
import { SearchOutlined } from "@ant-design/icons";
import { useLocation } from "@reach/router";
import config from '../../../config';

const getOneMonthAgo = () => {
    const today = new Date();
    today.setMonth(today.getMonth() - 1);
    return today;
};

const OfferList = ({ navigate }) => {
    const location = useLocation();
    const [openFilter, setOpenFilter] = useState(false)
    const [sortedList, setSortedList] = useState([])
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });
    const [filters, setFilters] = useState({
        bidNumber: "",
        bidStatus: null,
        customerName: "",
        endDate: new Date(),
        startDate: getOneMonthAgo(),
        representative: "",
        brandName: "",
        stockCode: "",
        stockName: ""
    })

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const page = parseInt(queryParams.get('pn')) || 1;
        const pageSize = parseInt(queryParams.get('ps')) || 10;

        getPaginatedData(page, pageSize);
    }, [location.search]);

    const getPaginatedData = (page, pageSize, offerFilters = filters) => {
        const mockFilters = {...offerFilters};
        mockFilters.pageSize = pageSize;
        mockFilters.pageNo = Number(page) - 1;

        getOffersWithPage(mockFilters)
            .then(({data}) => {
                if (data.content) {
                    sortData(data.content);
                    setPagination({
                        ...pagination,
                        current: page,
                        total: data.totalElements,
                        pageSize: pageSize
                    })
                }
            })
    }

    const toggleFilterDisplay = () => setOpenFilter(!openFilter)
    function handleFilter(filters) {
        const requestObj = {};
        filters.endDate =
            filters.endDate && filters.endDate.hasOwnProperty('_d') ? filters.endDate._d : config.limitDates.max;
        filters.startDate =
        filters.startDate && filters.startDate.hasOwnProperty('_d') ? filters.startDate._d : config.limitDates.min;

        Object.keys(filters).map(key => requestObj[key] = filters[key]);
        setFilters(requestObj);
        navigate(`?ps=${10}&pn=${1}&rn=${Math.floor(Math.random(1) * 1000)}`);
        return new Promise((resolve => resolve(200)))
    };
    const sortData = (list) => {
        const sorted = list.map((item, idx) => {
            return {
                key: item.id,
                rowKey: `${item.id}-${idx}`,
                bidNo: item.bn,
                offerFirmOfficer: item.r,
                offerCustomer: item.cn,
                offerDate: item.cd,
                offerStatus: item.bs,
                // offerBidList: item.bid.contentOfBidList || [],
                offerTotal: JSON.parse(item.c) || [],
                wos: item.wos
            }
        })
        setSortedList(sorted)
    };
    const triggerListUpdate = () => {
        getPaginatedData(1, 10);
    };

    const columns = [
        {
            title: 'Teklif Numarası',
            dataIndex: 'bidNo',
            key: 'bidNo'
        },
        {
            title: 'Müşteri',
            dataIndex: 'offerCustomer',
            key: 'offerCustomer'
        },
        {
            title: 'Firma Yetkilisi',
            dataIndex: 'offerFirmOfficer',
            key: 'offerFirmOfficer'
        },
        {
            title: 'Tekilf Tarihi',
            dataIndex: 'offerDate',
            key: 'offerDate',
            render: (text) => userDateFormatter(text)
        },
        {
            title: 'Toplam',
            dataIndex: 'offerTotal',
            key: 'offerTotal',
            render: (_, record) => {
                return record.offerTotal.map(({c, PiT}, idx) => {
                    return <p key={`offer-${c}-${idx}`}><span style={{fontWeight: 'bold'}}>{c}: </span>{new Intl.NumberFormat().format(PiT)}</p>
                })
            }
        },
        {
            title: 'Durum',
            dataIndex: 'offerStatus',
            key: 'offerStatus',
            render: (text) => (
                text === 'WAITING' ? <Tag color={"cyan"}>BEKLEMEDE</Tag> :
                    text === 'POSITIVE' ? <Tag color={"green"}>OLUMLU </Tag> :
                        text === 'NEGATIVE' ? <Tag color={"red"}>OLUMSUZ</Tag> : null

            ),
            filters: [{ text: 'OLUMLU', value: 'POSITIVE' }, { text: 'OLUMSUZ', value: 'NEGATIVE' }, { text: 'BEKLEMEDE', value: 'WAITING' }],
            onFilter: (value, record) => record.offerStatus === value

        },
        {
            title: 'Depo Çıkış Durumu',
            dataIndex: 'wos',
            key: 'wos',
            render: (t, r) => r.wos ? <Tag color={'green'}>TAMAMLANDI</Tag> :
                <Tag color={'red'}>TAMAMLANMADI</Tag>,
            filters: [{ text: 'TAMAMLANDI', value: true }, { text: 'TAMAMLANMADI', value: null }],
            onFilter: (value, record) => record.wos === value
        },
        // {
        //     title: 'İçerik',
        //     dataIndex: 'offerContent',
        //     render: (text, {offerBidList}) => <OfferReadBidContent bidList={offerBidList}/>
        // },
        {
            title: 'İşlemler',
            render: (text, record) => <OfferActions offerId={record.key} updater={triggerListUpdate} />
        }
    ];

    const handlePaginationChange = (pageNumber, pageSize) => {
        navigate(`?ps=${pageSize}&pn=${pageNumber}`);
    };

    const handleFilterReset = () => {
        const requestObj = {
            bidNumber: "",
            bidStatus: null,
            customerName: "",
            endDate: new Date(),
            startDate: getOneMonthAgo(),
            representative: "",
            brandName: "",
            stockCode: "",
            stockName: ""
        };
        getPaginatedData(1, 10, requestObj)
    };
    return (
        <React.Fragment>
            <div>
                <Row justify={"start"}>
                    <div className={'filter-row-container'} onClick={toggleFilterDisplay}><SearchOutlined /></div>
                </Row>
                <Table
                    scroll={{ x: 'max-content' }}
                    rowKey={'rowKey'}
                    columns={columns}
                    dataSource={sortedList}
                    pagination={{
                        ...pagination,
                        showSizeChanger: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        onChange: handlePaginationChange,
                    }}
                />
            </div>
            {
                <Filter
                    showDrawer={openFilter}
                    closer={toggleFilterDisplay}
                    relatedComponent={'Teklif'}
                    handler={handleFilter}
                    resetHandler={handleFilterReset}
                >
                    <OfferFilter />
                </Filter>
            }
        </React.Fragment>
    )
}
export default OfferList